module.exports = __webpack_public_path__ + "static/img/Bachelor_010691.dad135c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010691.jpg
// module id = 217
// module chunks = 0